import { dinero, toSnapshot } from 'dinero.js';
import * as currencies from '@dinero.js/currencies';

export interface MoneyAmount {
  amount: number;
  currency: string;
}

type NumberCurrency = Parameters<typeof dinero>[0]['currency'];

const currencyRegistry = currencies as unknown as Record<string, NumberCurrency>;

function resolveCurrency(code: string): NumberCurrency {
  const cur = currencyRegistry[code];
  if (!cur) {
    throw new Error(`Unknown currency code: ${code}`);
  }
  return cur;
}

export function formatMoney(money: MoneyAmount, locale: string = 'en-US'): string {
  if (!Number.isInteger(money.amount)) {
    throw new Error(`formatMoney requires integer minor units, got: ${money.amount}`);
  }
  const cur = resolveCurrency(money.currency);
  const d = dinero({ amount: money.amount, currency: cur });
  const snap = toSnapshot(d);
  const base = Array.isArray(snap.currency.base) ? snap.currency.base[0] : snap.currency.base;
  if (typeof base !== 'number') {
    throw new Error(`Unsupported currency base for ${money.currency}`);
  }
  const divisor = base ** snap.scale;
  const majorUnits = snap.amount / divisor;

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: money.currency,
    minimumFractionDigits: snap.scale,
    maximumFractionDigits: snap.scale,
  }).format(majorUnits);
}
